import { render, staticRenderFns } from "./MarketplaceStatuses.vue?vue&type=template&id=1431a31a&"
import script from "./MarketplaceStatuses.vue?vue&type=script&lang=js&"
export * from "./MarketplaceStatuses.vue?vue&type=script&lang=js&"
import style0 from "./MarketplaceStatuses.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports